module.exports = __webpack_public_path__ + "static/img/sishini.0737a331.png";